function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(0 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 1.08,
  ry: 1.08,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1.25s",
  begin: "-1.0714285714285714s",
  repeatCount: "indefinite"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(51.42857142857143 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 1.08,
  ry: 1.08,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1.25s",
  begin: "-0.8928571428571428s",
  repeatCount: "indefinite"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(102.85714285714286 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 1.08,
  ry: 1.08,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1.25s",
  begin: "-0.7142857142857142s",
  repeatCount: "indefinite"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(154.28571428571428 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 1.08,
  ry: 1.08,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1.25s",
  begin: "-0.5357142857142857s",
  repeatCount: "indefinite"
})));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(205.71428571428572 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 1.08,
  ry: 1.08,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1.25s",
  begin: "-0.3571428571428571s",
  repeatCount: "indefinite"
})));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(257.14285714285717 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 1.08,
  ry: 1.08,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1.25s",
  begin: "-0.17857142857142855s",
  repeatCount: "indefinite"
})));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  transform: "rotate(308.57142857142856 50 50)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 47,
  y: 24,
  rx: 1.08,
  ry: 1.08,
  width: 6,
  height: 12,
  fill: "#ffffff"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "opacity",
  values: "1;0",
  keyTimes: "0;1",
  dur: "1.25s",
  begin: "0s",
  repeatCount: "indefinite"
})));

function SvgLoadingSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "block",
      shapeRendering: "auto"
    },
    width: "61px",
    height: "30px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingSpinner);
export default __webpack_public_path__ + "static/media/loadingSpinner.e5c13bb52ea62a00a42aacc922dd965d.svg";
export { ForwardRef as ReactComponent };